const zhCommon = {
  nav: {
    home: '首页',
    category: '分类',
    ranking: '排行',
    favorites: '收藏',
    history: '历史',
    search: '搜索',
    login: '登录',
    searchPlaceholder: '搜索漫画...',
  },
  footer: {
    subscribeTitle: '订阅更新',
    subscribeDesc: '第一时间获取最新韩漫上架信息和阅读推荐',
    subscribePlaceholder: '输入您的邮箱',
    subscribeBtn: '订阅',
    navigation: '快速导航',
    contact: '联系我们',
    phone: '客服电话',
    email: '电子邮箱',
    address: '公司地址',
    phoneValue: '400-888-6666',
    emailValue: 'hello@zzxcdell.com',
    addressValue: '上海市浦东新区张江高科技园区',
    copyright: '© 2026 韩漫画网 版权所有',
    privacy: '隐私政策',
    terms: '服务条款',
    about: '关于我们',
    help: '帮助中心',
    feedback: '意见反馈',
  },
  hero: {
    title1: '韩漫大全下拉式免费',
    title2: '无遮挡沉浸阅读',
    title3: '纯粹漫画享受',
    subtitle1: '海量韩漫资源，每日更新不停歇。热血、恋爱、奇幻、悬疑——你想要的都在这里。',
    subtitle2: '下拉式无遮挡阅读，加载迅速零干扰，专注每一格精彩故事。',
    cta: '开始阅读',
    browseCategory: '浏览分类',
  },
  latest: {
    title: '最新更新',
    subtitle: '每日新鲜内容，追更不等待',
    updatedTo: '更新至',
    chapter: '话',
  },
  category: {
    title: '热门分类',
    action: '动作热血',
    romance: '浪漫恋爱',
    fantasy: '奇幻冒险',
    thriller: '悬疑惊悚',
    comedy: '搞笑日常',
    drama: '剧情人生',
    exploreAll: '查看全部分类',
  },
  testimonial: {
    label: '读者口碑',
    title: '数百万读者的选择',
  },
  cta: {
    title: '开启你的韩漫之旅',
    subtitle1: '无需注册，即刻畅读上千部精选韩漫',
    subtitle2: '无遮挡下拉式体验，沉浸故事不中断',
    btn: '立即免费阅读',
  },
  breadcrumb: {
    home: '首页',
  },
};

export default zhCommon;